import React from 'react';
import './Navbar.css';

const Navbar = ({ title }) => {
  return (
    <nav className="navbar">
      <div className="container">
        <div className="navbar-content">
          <span className="navbar-brand">{title}</span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
